import { gql } from 'apollo-boost';

export const DELETE_CHAT_ACTION = gql`
    mutation DeleteChatAction($data: DeleteChatActionInput!) {
        deleteChatAction(data: $data)
    }
`;
